import { render, staticRenderFns } from "./ShippingMethods.vue?vue&type=template&id=f031139a&"
import script from "./ShippingMethods.vue?vue&type=script&lang=ts&"
export * from "./ShippingMethods.vue?vue&type=script&lang=ts&"
import style0 from "./ShippingMethods.vue?vue&type=style&index=0&id=f031139a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VDataTable,
  VFlex,
  VIcon,
  VLayout,
  VSpacer,
  VSwitch,
  VTooltip,
})
